var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetalleSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.003,
    height: 21.608,
    viewBox: "0 0 27.003 21.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f5f5f5;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inspeccionar",
    transform: "translate(-10.17 61.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    className: "cls-1",
    d: "M43.008-60.473a5.014,5.014,0,0,0-6.98,1.247,5.014,5.014,0,0,0,1.247,6.98,5.014,5.014,0,0,0,6.386-.542l4.4,3.069A.749.749,0,0,0,49.1-49.89l.014-.02.191-.272a.749.749,0,0,0-.171-1.046l-.02-.014-4.4-3.069a5.013,5.013,0,0,0-1.711-6.165Zm-.082,6.056a3.394,3.394,0,0,1-4.725.841A3.393,3.393,0,0,1,37.36-58.3a3.393,3.393,0,0,1,4.724-.842,3.417,3.417,0,0,1,.846,4.73Z",
    transform: "translate(-12.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    className: "cls-1",
    d: "M26.256-40.9V-39.3H24.648v1.608h1.608v1.608H13.387l0-1.608H15V-39.3H13.388l0-1.608,1.426-4.276a.805.805,0,0,1,.764-.552h7.477a6.063,6.063,0,0,1-.894-1.608H15.576a2.41,2.41,0,0,0-2.29,1.651l-1.059,3.177h-.449A1.608,1.608,0,0,0,10.17-40.9h1.608v7.238a.8.8,0,0,0,.8.8h1.608a.8.8,0,0,0,.8-.8v-.8h9.653v.8a.8.8,0,0,0,.8.8h1.61a.805.805,0,0,0,.8-.8V-40.9h1.608a1.608,1.608,0,0,0-1.608-1.608h-.451l-.3-.9a6.039,6.039,0,0,1-1.878-.552Z",
    transform: "translate(0 -6.904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    className: "cls-1",
    d: "M29.318-37.788l-1.073-3.217H20.912l-1.073,3.217Z",
    transform: "translate(-4.757 -10.021)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetalleSelected);
export default __webpack_public_path__ + "static/media/detalle-selected.3aad683ebaf902fcb5f73ba4535b69b0.svg";
export { ForwardRef as ReactComponent };